module.exports = __webpack_public_path__ + "static/media/proj15_img9.19842135.jpg";